
import React from "react";
import { Earth } from "lucide-react";
import { Button } from "@/components/ui/button";
import Search from "./Search";

const Hero = () => {
  return (
    <div className="relative bg-gradient-to-b from-eco-50 to-transparent py-20 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6" aria-hidden="true">
          <div
            className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-eco-200 to-eco-400 opacity-30"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
      <div className="mx-auto max-w-4xl text-center">
        <div className="flex justify-center mb-6">
          <Earth className="h-16 w-16 text-eco-500" />
        </div>
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl">
          Rooted in community, <span className="text-eco-500">grown for change</span>
        </h1>
        <p className="mt-6 text-lg leading-8 text-muted-foreground max-w-2xl mx-auto">
          Ourcelium is a living guide to the UK's eco-conscious world. From local shops to wild spaces, find the people and projects making a difference.
        </p>
        <div className="mt-10">
          <Search />
        </div>
        <div className="mt-8 flex items-center justify-center gap-x-6">
          <Button className="bg-eco-500 hover:bg-eco-600">Explore Now</Button>
          <Button variant="outline" className="border-eco-500 text-eco-500 hover:bg-eco-500 hover:text-white">
            About Our Mission
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
